<div *ngIf="isAdmin || fpsHaveChartData" class="row-container row-gap-1">
  <app-pie-chart-simple
    data-qa="pie-chart-commitment-allocation"
    class="main padding-1p25 position-rel min-height-10 width-49pcnt"
    [data]="chartsData.commitmentAllocation"
    [isAdmin]="isAdmin"
    (editClicked)="showCommitmentAllocationModalForUpdate()"
  />
  <app-pie-chart-simple
    data-qa="pie-chart-opex"
    class="main padding-1p25 position-rel min-height-10 width-49pcnt"
    [data]="chartsData.opexDrillDown"
    [isAdmin]="isAdmin"
    (editClicked)="showFpUpdateModal()"
  />
</div>

<app-fp-commitment-allocation
  *ngIf="showModal.commitmentAllocation"
  [fundPerformance]="selected.fp"
  (fundPerfSetter)="updateFpFromModal($event)"
  (isConfirmedUpdate)="closeModalAfterUpdate()"
/>

<app-modal-fund-performance-update
  *ngIf="showModal.fundPerformance"
  [fundPerformanceList]="fps"
  [selected]="selected"
  (fundPerfSetter)="updateFpFromModal($event)"
  (isConfirmedUpdate)="closeModalAfterUpdate()"
  (deleteFundPerformance)="showModalForDeleteFP()"
/>

<app-modal-dialog
  *ngIf="showModal.deleteFundPerformance"
  [header]="'Delete period'"
  [useStandardList]="false"
  [mainText]="textListDeletePeriod"
  (isConfirmed)="deleteFundPerformance($event)"
/>
